import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flex _jc-sb _bgc--light _px-3 _py-2 _ai-c _rounded--common" }
const _hoisted_2 = { "format-key": "0" }
const _hoisted_3 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_contact_back = _resolveComponent("contact-back")
  const _component_contact_current_group_header = _resolveComponent("contact-current-group-header")
  const _component_base_title = _resolveComponent("base-title")
  const _component_localize = _resolveComponent("localize")
  const _component_login_button = _resolveComponent("login-button")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock(_component_box, { "data-qa": "contact-form-unauthorized" }, {
    default: _withCtx(() => [
      _createVNode(_component_contact_back, {
        class: "_mb-3",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('back')))
      }),
      _createVNode(_component_contact_current_group_header, _normalizeProps(_guardReactiveProps({ currentCategoryGroup: $props.currentCategoryGroup, currentProject: $props.currentProject })), null, 16 /* FULL_PROPS */),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_base_title, {
            level: "h3",
            as: "h4",
            class: "gfu-hd gfu-hd--h3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.Contact.LogInToSendMessageHeader), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_localize, {
            resource: _ctx.Resources.Contact.LogInToSendMessageParagraph
          }, {
            default: _withCtx(() => [
              _createElementVNode("em", _hoisted_2, [
                _createElementVNode("a", {
                  href: $options.createAccountUrlWithReturn,
                  "data-qa": "project-comments-button:CreateAccount"
                }, _toDisplayString(_ctx.Resources.Contact.SignUpLink), 9 /* TEXT, PROPS */, _hoisted_3)
              ]),
              _cache[1] || (_cache[1] = _createTextVNode(". ", -1 /* CACHED */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["resource"])
        ]),
        _createVNode(_component_login_button, {
          theme: "accent",
          "return-url": $options.loginUrlWithReturn
        }, null, 8 /* PROPS */, ["return-url"])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}